import React from 'react'
import Insights from '../cityLoop-Dashboard/Dashboard'

const MainContent = () => {
  return (
    <Insights />
  )
}

export default MainContent